import React from 'react';
import { globalConfig } from 'applicationConfig';
import OktaAuth from '@okta/okta-auth-js';

import userStore from 'stores/UserStore';

const CONFIG = {
  url: globalConfig.OKTA_AUTH_BASE_URL,
  clientId: globalConfig.OKTA_AUTH_CLIENT_ID,
  redirectUri: globalConfig.OKTA_AUTH_REDIRECT_URI
};

const AUTH_PARAMS = {
  issuer: globalConfig.OKTA_AUTH_ISSUER,
  responseType: [ 'code' ],
  responseMode: 'query',
  scopes: [ 'openid', 'profile', 'email' ]
};

class Auth {
  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.signIn = this.signIn.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);

    this.authClient = new OktaAuth(CONFIG);
  }

  isAuthenticated() {
    // auth status is  managed by userStore
    return userStore.isAuthenticated;
  }

  login(history) {
    // Redirect to the login page
    history.push('/login');
  }

  async logout(history) {
    await userStore.logout();
  }

  signIn(login, password) {
    userStore.onLoggingInStart();
    const authClient = this.authClient;

    const errorHandler = (error) => {
      userStore.onLoggingInEnd();
      throw error;
    };

    return authClient
      .signIn({
        username: login,
        password: password
      })
      .then((response) => {
        return authClient.token.getWithRedirect({
          ...AUTH_PARAMS,
          sessionToken: response.sessionToken
        });
      }, errorHandler);
  }
}

// create a singleton
const auth = new Auth();
export const withAuth = (WrappedComponent) => (props) => <WrappedComponent auth={auth} {...props} />;



// WEBPACK FOOTER //
// ./src/common/auth/Auth.jsx